export default function ImageBlock({ url, alt }: { url: string; alt: string; }) {
    return (
        <div className="my-4">
            <img src={url} alt={alt} className="mx-auto max-w-96" />
            {alt && <legend className="text-center italic text-sm text-gray-500 mt-1" dangerouslySetInnerHTML={{ __html: alt }} />}
        </div>
    );
}